import React from "react";
import { Link } from "react-router-dom";
import { imageUrl } from "../utils/branding";
import { useProfile } from "../hooks/useProfile";
import { IconLogout, IconMenu } from "./ui/icons";
import { useCompanyInfo } from "../hooks/useCompanyInfo";
import ThemeToggle from "./ui/ThemeToggle";

export default function TopHeader({ title, user, onLogout, onMenuClick }) {
  const { companyName } = useCompanyInfo();
  const { user: profile } = useProfile();
  const displayName = user?.username || user?.name || user?.ime;
  const initial = displayName ? displayName.charAt(0).toUpperCase() : "?";

  return (
    <header className="sticky top-0 z-header flex h-14 shrink-0 items-center gap-3 border-b border-slate-200 bg-surface/95 px-4 backdrop-blur dark:border-slate-800 dark:bg-slate-900/95 sm:px-6">
      <button
        type="button"
        onClick={onMenuClick}
        aria-label="Otvori meni"
        className="-ml-1.5 inline-flex h-9 w-9 items-center justify-center rounded-md text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-50 lg:hidden"
      >
        <IconMenu className="text-xl" aria-hidden="true" />
      </button>

      <div className="min-w-0 leading-tight">
        <h1 className="truncate text-[15px] font-semibold text-slate-900 dark:text-slate-50">{title}</h1>
        {companyName && <p className="truncate text-xs text-slate-500 dark:text-slate-400">{companyName}</p>}
      </div>

      <div className="ml-auto flex items-center gap-1">
        <ThemeToggle />

        {displayName && (
          <Link
            to="/profile"
            aria-label={`Moj profil: ${displayName}`}
            className="ml-1 flex items-center gap-2 rounded-md border-l border-slate-200 py-1 pl-3 pr-1.5 transition-colors hover:bg-slate-100 dark:border-slate-800 dark:hover:bg-slate-800"
          >
            {profile?.has_avatar ? (
              <img src={imageUrl("avatar", null, profile.avatar_v)} alt="" className="h-7 w-7 rounded-md object-cover" />
            ) : (
              <span
                aria-hidden="true"
                className="flex h-7 w-7 items-center justify-center rounded-md bg-primary/10 text-xs font-semibold text-primary dark:bg-primary/20 dark:text-primary-light"
              >
                {initial}
              </span>
            )}
            <span className="hidden max-w-[10rem] truncate text-sm font-medium text-slate-700 dark:text-slate-200 sm:inline">{displayName}</span>
          </Link>
        )}

        {onLogout && (
          <button
            type="button"
            onClick={onLogout}
            aria-label="Odjavi se"
            title="Odjavi se"
            className="inline-flex h-9 w-9 items-center justify-center rounded-md text-slate-500 transition duration-150 hover:bg-slate-100 hover:text-slate-900 active:translate-y-px dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-50"
          >
            <IconLogout className="text-lg" aria-hidden="true" />
          </button>
        )}
      </div>
    </header>
  );
}
